// Mirrors DEFAULT_TERMS_HTML in the API (proposalPolicy).
export const DEFAULT_TERMS_HTML =
  '<p>Door akkoord te gaan met deze offerte gaat u tevens akkoord met onze algemene voorwaarden.</p>';

/**
 * Whether a rich-text value has no visible text. An emptied WYSIWYG editor
 * still produces markup such as `<p></p>`, which must count as "not set".
 * Mirrors isBlankRichText in the API (proposalPolicy).
 */
export function isBlankRichText(html) {
  if (typeof html !== 'string') return true;
  return (
    html
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;|\u00a0/g, '')
      .trim() === ''
  );
}

/**
 * Stored terms HTML to render at the bottom of a proposal.
 *
 * Mirrors selectProposalTermsHtml in the API (proposalPolicy): a proforma uses
 * `proforma_general_terms` when it has text, everything else (and a proforma
 * without its own text) uses `general_terms`. Returns null when neither has
 * text so the caller renders its default sentence.
 */
export function selectProposalTermsHtml(settings, proposalType) {
  if (proposalType === 'proforma' && !isBlankRichText(settings?.proforma_general_terms)) {
    return settings.proforma_general_terms;
  }
  return isBlankRichText(settings?.general_terms) ? null : settings.general_terms;
}

/**
 * Terms HTML to render for a proposal. Mirrors resolveProposalTermsHtml in the
 * API: the text frozen when the proposal was sent (`terms_html`), otherwise the
 * live organization terms for its type, otherwise the default.
 */
export function resolveProposalTermsHtml(proposal) {
  if (!isBlankRichText(proposal?.terms_html)) return proposal.terms_html;
  return (
    selectProposalTermsHtml(proposal?.organizations?.settings, proposal?.proposal_type) ||
    DEFAULT_TERMS_HTML
  );
}
